import placeholderImage from "figma:asset/a6098568789476e4b49d54b85cb54080b0402871.png";

/**
 * Determines if a product should use the placeholder image
 * Uses a hash of the product ID to ensure consistency (same product always gets same result)
 * Returns true for approximately 25% of products
 */
export function shouldUsePlaceholder(productId: string): boolean {
  // Simple hash function to get a consistent number from product ID
  let hash = 0;
  for (let i = 0; i < productId.length; i++) {
    const char = productId.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  // Use modulo 4 to get ~25% chance (when result is 0)
  return Math.abs(hash) % 4 === 0;
}

/**
 * Gets the appropriate image URL for a product
 * Returns placeholder for ~25% of products, otherwise returns a default gradient placeholder
 */
export function getProductImage(productId: string): string | null {
  if (shouldUsePlaceholder(productId)) {
    return placeholderImage;
  }
  return null; // Return null to show the default gradient placeholder
}

/**
 * Export the placeholder image for direct use
 */
export { placeholderImage };
